import { app } from './firebase';
import {
  getAuth,
  signInWithCustomToken,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth';
import { db } from './firebase';

import { setDoc, doc, updateDoc, getDoc, Query, where, query, documentId } from 'firebase/firestore';
import { SpotLockUser } from '../sp-types/userType';
import { getAllItems, updateItem } from './genericFB';

export async function createUserAccount(data: any, userId: string) {
  await setDoc(doc(db, 'users', userId), data);
}

export async function updateUserAccount(userId: string, accountId: string) {
  try {
    await updateDoc(doc(db, 'users', userId), { accountId });
    console.log('Account been set successfully');
  } catch (err) {
    console.log(`error found! ${err}`);
  }
}

export function updateUserPassword(token: string, newPassword: string) {
  const auth = getAuth(app);
  signInWithCustomToken(auth, token)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      if (user) {
        updatePassword(user, newPassword)
          .then(() => {
            // Update successful.
          })
          .catch((error) => {
            console.log(error);
          });
      }
      // ...
    })
    .catch((error) => {
      console.error(error);
      // ...
    });
}

export async function changeUserPassword(oldPassword: string, newPassword: string): Promise<void> {
  const auth = getAuth(app);
  const user = auth.currentUser;

  if (!user || !user.email) {
    throw new Error('No authenticated user found');
  }

  try {
    // Re-authenticate user with old password
    const credential = EmailAuthProvider.credential(user.email, oldPassword);
    await reauthenticateWithCredential(user, credential);

    await updatePassword(user, newPassword);

    console.log('Password updated successfully');
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
}

export async function getUserDetails(id: string): Promise<SpotLockUser | null> {
  const auth = getAuth(app);
  // Important for account Fetching (no clue why)
  const user = auth.currentUser;

  const docRef = doc(db, 'users', id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const spotLockUserData = docSnap.data();
    spotLockUserData.id = docSnap.id;
    return spotLockUserData as SpotLockUser;
  }
  return null;
}

export async function getAllUsers(): Promise<SpotLockUser[] | undefined> {
  return getAllItems<SpotLockUser>('users', undefined, true);
}

export async function getUsersByIds(userIds: string[]): Promise<SpotLockUser[] | undefined> {
  return getAllItems<SpotLockUser>('users', (q: Query) => query(q, where(documentId(), 'in', userIds)), true);
}

export async function updateUserProperty(userId: string, property: string, value: any): Promise<SpotLockUser | null> {
  return await updateItem<SpotLockUser>(userId, { [property]: value }, 'users');
}
